class MRTSection {
  constructor(sectionEl, data) {
    this.sectionEl = sectionEl;
    this.data = data;
    this.marqueeEl = sectionEl.querySelector('marquee-scroll');
    this.trackEl = sectionEl.querySelector('.mrt-track');

    this._bindEvents();
  }

  static escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  _buildTrackHTML(items) {
    return items
      .map(text => {
        const parts = String(text).split('##');

        const inner = parts
          .map((part, i) => {
            if (!part) return '';

            const cls =
              i % 2 === 0
                ? 'mrt-text1'
                : 'mrt-text2';

            return `
              <span class="${cls}">
                ${MRTSection.escapeHtml(part)}
              </span>
            `;
          })
          .join('');

        return `
          <span class="mrt-item">
            ${inner}
          </span>

          <span class="mrt-separator" aria-hidden="true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L14.9 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L9.1 8.26L12 2Z"/>
            </svg>
          </span>
        `;
      })
      .join('');
  }

  /**
   * Preserve marquee position
   */
  _getCurrentTranslateX(el) {
    const style = window.getComputedStyle(el);
    const matrix = new DOMMatrixReadOnly(style.transform);

    return matrix.m41 || 0;
  }

  _refreshMarquee(html) {
    if (!this.marqueeEl) return;

    const tracks =
      this.marqueeEl.querySelectorAll('.mrt-track');

    tracks.forEach(track => {
      // Save current position
      const currentX =
        this._getCurrentTranslateX(track);

      // Temporarily stop animation
      track.style.animation = 'none';
      track.style.transform =
        `translateX(${currentX}px)`;

      // Force reflow
      track.offsetHeight;

      // Update content
      track.innerHTML = html;

      requestAnimationFrame(() => {
        // Restore transform
        track.style.transform =
          `translateX(${currentX}px)`;

        // Restore animation
        track.style.animation = '';
      });
    });
  }

  update(variantId) {
    const vData =
      this.data.variants &&
      this.data.variants[String(variantId)];

    const items =
      vData &&
      vData.items &&
      vData.items.length
        ? vData.items
        : null;

    if (!this.trackEl) return;

    // Background update
    if (vData && vData.bg && this.marqueeEl) {
      this.marqueeEl.style.backgroundColor =
        vData.bg;
    }

    // Content update
    if (items) {
      const html =
        this._buildTrackHTML(items);

      this._refreshMarquee(html);

      this.sectionEl.classList.remove(
        'mrt-no-data'
      );
    } else {
      this._refreshMarquee('');

      this.sectionEl.classList.add(
        'mrt-no-data'
      );
    }
  }

  _bindEvents() {
    document.addEventListener(
      'variant-change',
      e => {
        if (
          e.detail &&
          e.detail.variant &&
          e.detail.variant.id
        ) {
          this.update(
            String(e.detail.variant.id)
          );
        }
      }
    );

    document.body.addEventListener(
      'change',
      e => {
        const t = e.target;

        if (
          t &&
          t.name === 'id' &&
          t.form &&
          String(t.form.id || '').indexOf(
            'product-form-'
          ) === 0
        ) {
          this.update(t.value);
        }
      }
    );
  }

  static init() {
    document
      .querySelectorAll('[data-mrt-section]')
      .forEach(sectionEl => {
        const sectionId =
          sectionEl.getAttribute(
            'data-section-id'
          );

        if (!sectionId) return;

        const scriptEl =
          document.getElementById(
            'mrt-data-' + sectionId
          );

        if (!scriptEl) return;

        let data;

        try {
          data = JSON.parse(
            scriptEl.textContent
          );
        } catch (e) {
          return;
        }

        new MRTSection(sectionEl, data);
      });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    MRTSection.init
  );
} else {
  MRTSection.init();
}